if (typeof Connect == 'undefined') Connect = { contextRoot: '/connect' };
Connect.UngappedSurveyStatistics = Backbone.Epoxy.Model.extend({
    urlRoot: Connect.contextRoot + '/ungapped/survey/statistics',
    computeds: {
        
    }
});